var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgFacebookColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0866ff;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-2",
    "data-name": "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Initiator",
    className: "cls-1",
    d: "M600,350c0-138.07-111.93-250-250-250S100,211.93,100,350c0,117.24,80.72,215.62,189.61,242.64V426.4H238.05V350h51.56V317.08c0-85.09,38.5-124.53,122-124.53,15.84,0,43.17,3.1,54.35,6.21V268c-5.9-.62-16.15-.93-28.88-.93-41,0-56.83,15.53-56.83,55.9v27H462l-14,76.4H380.29V598.17C504.07,583.22,600,477.82,600,350Z",
    transform: "translate(-100 -100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-2",
    d: "M447.92,426.4,462,350H380.29V323c0-40.37,15.84-55.9,56.83-55.9,12.73,0,23,.31,28.88.93V198.76c-11.18-3.11-38.51-6.21-54.35-6.21-83.54,0-122,39.44-122,124.53V350H238.05v76.4h51.56V592.64a251.49,251.49,0,0,0,90.68,5.53V426.4Z",
    transform: "translate(-100 -100)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookColored);
export default __webpack_public_path__ + "static/media/facebook-colored.2a43484129e757864b4e6c70ec1acd0f.svg";
export { ForwardRef as ReactComponent };